// extracted by mini-css-extract-plugin
export default {"button":"CategoryButton_button__lyrLq","select":"CategoryButton_select__bR1QH"};